import * as React from 'react';
import { FC, memo } from 'react';

import { InjectedFieldProps, PublicFieldProps } from 'react-admin';

import Typography, { TypographyProps } from '@material-ui/core/Typography';
import get from 'lodash/get';
import { useRecordContext } from 'ra-core';
import { shortenString } from 'shared/utils/helperFunctions/shortenString';

export const removeTags = (input: string) =>
  input ? input.replace(/<[^>]+>/gm, '') : '';

const RichTextFieldWithEllipsis: FC<RichTextFieldProps> =
  memo<RichTextFieldProps>((props) => {
    const { className, emptyText, source, stripTags, ...rest } = props;
    const record = useRecordContext(props);
    const value = get(record, source ?? '');

    return (
      <Typography
        className={className}
        variant='body2'
        component='span'
        {...rest}
      >
        {value == null && emptyText ? (
          emptyText
        ) : stripTags ? (
          removeTags(shortenString(value, props.stringLength))
        ) : (
          <span
            dangerouslySetInnerHTML={{
              __html: shortenString(value, props.stringLength)
            }}
          />
        )}
      </Typography>
    );
  });

RichTextFieldWithEllipsis.defaultProps = {
  addLabel: true,
  stripTags: false
};

export interface RichTextFieldProps
  extends PublicFieldProps,
    InjectedFieldProps,
    TypographyProps {
  stripTags?: boolean;
  stringLength: number;
}

RichTextFieldWithEllipsis.displayName = 'RichTextFieldWithCollapse';

export default RichTextFieldWithEllipsis;
